export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/404": [4],
		"/company/contact": [5],
		"/company/demo": [6],
		"/docs": [7,[2]],
		"/docs/architecture/how-on-tenant-works": [8,[2]],
		"/docs/architecture/multi-cloud": [9,[2]],
		"/docs/architecture/network-and-data-residency": [10,[2]],
		"/docs/architecture/publisher-access": [11,[2]],
		"/docs/architecture/what-gets-deployed": [12,[2]],
		"/docs/building-agents/assistants-and-sub-assistants": [13,[2]],
		"/docs/building-agents/channels": [14,[2]],
		"/docs/building-agents/intelligence-configuration": [15,[2]],
		"/docs/building-agents/publishing-and-versions": [16,[2]],
		"/docs/building-agents/tools-built-in": [17,[2]],
		"/docs/building-agents/tools-mcp": [18,[2]],
		"/docs/building-agents/tools-openapi": [19,[2]],
		"/docs/extending-corral/api-reference": [20,[2]],
		"/docs/extending-corral/building-custom-surfaces": [21,[2]],
		"/docs/extending-corral/client-credentials": [22,[2]],
		"/docs/extending-corral/for-partners": [23,[2]],
		"/docs/getting-started/concepts": [24,[2]],
		"/docs/getting-started/deploy-from-marketplace": [25,[2]],
		"/docs/getting-started/first-30-minutes": [26,[2]],
		"/docs/getting-started/what-is-corral": [27,[2]],
		"/docs/security-and-governance/audit-and-observability": [28,[2]],
		"/docs/security-and-governance/authentication": [29,[2]],
		"/docs/security-and-governance/cumulative-restrictions": [30,[2]],
		"/docs/security-and-governance/permissions": [31,[2]],
		"/docs/security-and-governance/security-architecture": [32,[2]],
		"/docs/using-corral/admin-console": [33,[2]],
		"/docs/using-corral/canvas": [34,[2]],
		"/docs/using-corral/embedded-widget": [35,[2]],
		"/docs/using-corral/the-hub": [36,[2]],
		"/learn": [37],
		"/learn/documentation": [38],
		"/learn/resources": [39],
		"/learn/tutorials": [40],
		"/news": [41],
		"/news/azure-marketplace-launch": [42],
		"/news/blog": [43],
		"/news/design-partner-program": [44],
		"/news/introducing-corral-ai": [45],
		"/news/upcoming-features-preview": [46],
		"/news/zero-trust-ai-architecture": [47],
		"/onboarding": [48],
		"/partners": [49],
		"/pricing": [50],
		"/product": [51],
		"/product/admin": [52],
		"/product/builder": [53],
		"/product/connectors": [54],
		"/product/hub": [55],
		"/product/security": [56],
		"/terms": [57],
		"/terms/compliance": [58],
		"/terms/privacy": [59],
		"/terms/tos": [60],
		"/use-cases/developers": [61],
		"/use-cases/it-security": [62],
		"/use-cases/ops-product": [63],
		"/use-cases/product-companies": [64],
		"/use-cases/service-providers": [65],
		"/why-corral": [66]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);